import type { TypographyColor, TypographyColorShade, TypographyVariant, TypographyWeight } from "./types";

export const variants = ["xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl"] as const;
export const colors = ["default", "primary", "success", "warning", "error"] as const;
export const colorShades = ["lighter", "light", "main"] as const;
export const weights = ["light", "regular", "medium", "bold"] as const;

export const DEFAULT_VARIANT = "base" satisfies TypographyVariant;
export const DEFAULT_COLOR = "default" satisfies TypographyColor;
export const DEFAULT_COLOR_SHADE = "main" satisfies TypographyColorShade;
export const DEFAULT_WEIGHT = "regular" satisfies TypographyWeight;
